import { atom } from 'jotai';
import { DEFAULT_PAGINATION } from '@/common/pagination/types.ts';

export const assetPaginationAtom = atom(DEFAULT_PAGINATION);

export const resetAssetPaginationOnFilterChangeAtom = atom(
  null,
  (_get, set) => {
    set(assetPaginationAtom, DEFAULT_PAGINATION);
  },
);
